import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTabMac = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M11 7c-2.75 0-5 2.25-5 5v26c0 2.75 2.25 5 5 5h28c2.75 0 5-2.25 5-5V12c0-2.75-2.25-5-5-5H11zm0 2h28c1.668 0 3 1.332 3 3v26c0 1.668-1.332 3-3 3H11c-1.668 0-3-1.332-3-3V12c0-1.668 1.332-3 3-3zm16.984 11.986A1 1 0 0 0 27 22v14a1 1 0 1 0 2 0V22a1 1 0 0 0-1.016-1.014zM19.99 23.99a1 1 0 0 0-.697 1.717L21.586 28H13a1 1 0 1 0 0 2h8.586l-2.293 2.293a1 1 0 1 0 1.414 1.414l3.912-3.912a1 1 0 0 0-.002-1.592l-3.91-3.91a1 1 0 0 0-.717-.303z" />
    </svg>
);
export default SvgTabMac;
